<template>
	<div class="cont_box">
		<div class="gall_box bai_box">
			<div class="gall_mbx">
				<el-breadcrumb separator=">">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<!-- <el-breadcrumb-item>图库</el-breadcrumb-item> -->
					<el-breadcrumb-item>
						<span @click="sp_btn">
							{{codeName.name}}
						</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item v-if="this.$route.query.zName">
						<span @click="k_btn">
							{{this.$route.query.zName}}
						</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item v-if="this.$route.query.kName">
						<span @click="k_btn">{{this.$route.query.kName}}</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item>{{this.$route.query.cName}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="desc_box">
				<div class="desc_cont">
					<div class="desc_title">
						<span class="zhs">
							{{cData.name}}
						</span>
					</div>
					<div class="desc_p">
						<span>中文名：</span>
						<span class="zhs">
							{{cData.cnName}}
						</span>
					</div>
					<div class="desc_p" v-if="cData.ptName">
						<span>
							俗名：
						</span>
						<span class="zhs">
							{{cData.ptName}}
						</span>
						
					</div>
					<div class="desc_p" v-if="cData.latinName">
						<span>
							拉丁名：
						</span>
						<span class="ld_font zhs">
							{{cData.latinName}}
						</span>
					</div>
					<div class="desc_p" v-if="cData.distribution">
						<span>
							分布：
						</span>
						{{cData.distribution}}
					</div>
					<div class="desc_p desc_fk" v-if="cData.host">
						<span>
							寄主：
						</span>
						<span class="des_c">
							{{cData.host}}
						</span>
					</div>
					<div class="desc_p" v-if="cData.remark">
						<span>
							形态：
						</span>
						<span class="des_c">
							{{cData.remark}}
						</span>
					</div>
				</div>
				<div class="desc_banner">
					<el-carousel height="225px" trigger="click" arrow="always">
						<el-carousel-item style="height: 225px;" v-for="(item,index) in cData.imgInfos" :key="index">
							<div class="bann_item">
								<img oncontextmenu="return false;" ondragstart="return false;" :src="item.url" alt="" class="img">
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			<div class="desc_chart">
				<div class="desc_chart_item" v-for="(item,index) in cData.imgInfos" :key="index">
					<div class="desc_chart_i">
						<div class="desc_chart_item_tit">
							<!-- <img oncontextmenu="return false;" ondragstart="return false;" src="../../assets/image/icon_logo_red.png" v-if="item.watermarkColor=='RED'" alt="" class="" style="width:82px;margin-right: 10px">
							<img oncontextmenu="return false;" ondragstart="return false;" src="../../assets/image/icon_logo_green.png" v-else-if="item.watermarkColor=='GREEN'" alt="" class="" style="width:82px;margin-right: 10px">
							<img oncontextmenu="return false;" ondragstart="return false;" src="../../assets/image/icon_logo_white.png" v-else alt="" class="" style="width:82px;margin-right: 10px"> -->
							<!-- <img oncontextmenu="return false;" ondragstart="return false;" src="../../assets/image/pic_tksy_logo@2x.png" alt="" class="icon"> -->
						</div>
						<img oncontextmenu="return false;" ondragstart="return false;" :src="item.url" alt="" class="img">
						<div class="desc_chart_item_bot" v-if="item.location">
							<img :src="item.qrCodeUrl" v-if="item.watermarkType == 'WX_CODE'" alt="" class="ew_img">
							<span v-if="item.watermarkType == 'AUTHOR'">拍摄者：{{item.author}}</span>
							<span v-if="item.watermarkType == 'CONCAT'">联系方式：{{item.concat}}</span>
							<span>{{item.location}}</span>
						</div>
					</div>
					<div class="desc_chart_p">
						{{item.remark}}
					</div>
				</div>
			</div>
			<!--关闭浏览版功能-->
<!-- 			<div class="desc_lyb">
				<div class="desc_lyb_title">
					留言板
				</div>
				<div class="desc_lyb_txt">
					<textarea name="" v-model="push_paramet.content" placeholder="请填写留言信息......"></textarea>
				</div>
				<div class="desc_lyb_fb">
					<div class="desc_lyb_input">
						<label for="">联系方式</label>
						<input type="text" v-model="push_paramet.concat" placeholder="请填写联系方式">
					</div>
					<div class="desc_lyb_btn" @click="lyb_btn">
						留言
					</div>
				</div>
				<div class="desc_lyb_list">
					<div class="desc_lyb_titles">
						全部留言 {{ly_data.records.length}}条
					</div>
					<div class="desc_lyb_item" v-for="(item,index) in ly_data.records" :key="index">
						<div class="desc_lyb_item_lef">
							<img src="../../assets/image/icon_lyb_tx@2x.png" alt="" class="tx_icon">
						</div>
						<div class="desc_lyb_item_rig">
							<div class="desc_lyb_item_name">
								{{item.name}}
							</div>
							<div class="desc_lyb_item_p">
								{{item.content}}
							</div>
							<div class="desc_lyb_item_time">
								{{item.createTime}}
							</div>
						</div>
					</div>
					<div class="desc_lyb_item_fot" :style="{'cursor': gd_flag?'pointer':'auto'}" @click="ck_btn">
						{{gd_flag?'查看更多':'没有更多信息了'}}
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import headers from '@/components/header';
	import foot from '@/components/foot';
	export default {
		name: "UserDialong",
		data() {
			return {
				not_flag: true,
				tab_index: 'tk',
				currentPage3: 5,
				cData: '', // 虫信息
				ly_data: {
					records: []
				},
				paramet: {
					type: 'GALLERY',
					id: this.$route.query.id,
					page: 1,
					size: 10,
				},
				type: this.$route.query.type,
				push_paramet: {
					concat: '', // 联系方式
					content: '', // 评论内容 
					id: this.$route.query.id,
					type: 'GALLERY',
				},
			}
		},
		mounted() {
			this.init()
		},
		computed:{
			gd_flag() {
				if (this.ly_data.current == this.ly_data.pages || this.ly_data.pages == 0) {
					return false
				} else {
					return true
				}
			},
			codeName() {
				let name = ''
				for (let item of this.fldata) {
					if (item.code == this.gallyIndex) {
						name = item
					}
				}
				return name
			},
			gallyIndex() {
				return this.$store.state.gallyIndex
			},
			fldata() {
				return this.$store.state.fldata
			}
		},
		methods: {
			k_btn() {
				this.$router.go(-1)
			},
			sp_btn() {
				if(this.type){
					this.$router.push({
						path: 'galleryIndex'
					})
				}else{
					this.$router.push({
						path: 'gallery_indexTw'
					})
				}
			},
			ck_btn() {
				if(this.gd_flag){
					this.paramet.page++
					this.ly_fn()
				}
			},
			init() {
				this.$http.get(`/front/gallery/${this.$route.query.id}`).then(res => {
					this.cData = res.data
					this.ly_fn()
				})
			},
			lyb_btn() {
				if (!this.push_paramet.content) {
					this.$message({
						message: '评论内容不能为空哦',
						type: 'warning'
					});
					return
				}
				if (!this.push_paramet.concat) {
					this.$message({
						message: '联系方式不能为空哦',
						type: 'warning'
					});
					return
				}
				// if (this.push_paramet.concat.length!=11) {
				// 	this.$message({
				// 		message: '请输入正确的联系方式',
				// 		type: 'warning'
				// 	});
				// 	return
				// }
				this.$http.put(`/front/comment`,this.push_paramet).then(res => {
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.push_paramet.concat = ''
					this.push_paramet.content = ''
				})
			},
			ly_fn() {
				this.$http.get('/front/comment', this.paramet).then(res => {
					if(res.data.current==1){
						this.ly_data = res.data
					}else{
						let data = this.ly_data.records.conent(res.data.records)
						let datas = res.data
						datas.records = data
						this.ly_data = datas
					}
				})
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			}
		},
		components: {
			headers,
			foot,
		}
	}
</script>

<style lang="less" scoped>
	/deep/ .el-carousel__button {
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background-color: rgba(255, 255, 255, .4);
	}

	/deep/ .is-active {
		.el-carousel__button {
			background-color: rgba(255, 255, 255, 1);
		}
	}
	#w-e-text-container{
		height: 600px;
	}
	
	.desc_lyb{
		margin-top: 90px;
		.desc_lyb_title{
			font-size: 18px;
			color: #333333;
			margin-bottom: 23px;
			padding-left: 23px;
			font-weight: bold;
		}
		.desc_lyb_txt{
			width: calc(100% - 72px);
			box-sizing: border-box;
			margin: 0 auto ;
			height: 90px;
			padding: 15px 31px;
			border-radius: 8px;
			background: #F5F5F5;
			textarea{
				width: 100%;
				height: 100%;
				border: none;
				resize:none;
				outline: none;
				background: transparent;
			}
		}
		.desc_lyb_fb{
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 36px 37px;
			box-sizing: border-box;
			margin: 23px auto 0;
			border-bottom: 1px dashed #E5E5E5;
			.desc_lyb_input{
				width: 349px;
				height: 53px;
				background: #F5F5F5;
				display: flex;
				padding-left: 30px;
				border-radius: 8px;
				label{
					color: #333333;
					font-size: 13px;
					line-height: 53px;
					margin-right: 30px;
				}
				input{
					flex: 1;
					height: 100%;
					background: transparent;
					outline: none;
					font-size: 13px;
				}
			}
			.desc_lyb_btn{
				width: 195px;
				height: 45px;
				background-color: #22AB67;
				border-radius: 22.5px;
				text-align: center;
				line-height: 45px;
				font-size: 18px;
				color: #fff;
				cursor: pointer;
			}
		}
		.desc_lyb_list{
			padding: 37px 36px;
			.desc_lyb_titles{
				color: #333333;
				font-size: 15px;
				margin-bottom: 37px;
			}
			.desc_lyb_item_fot{
				padding: 23px 0;
				text-align: center;
				color: #333333;
				font-size: 12px;
				cursor: pointer;
			}
			.desc_lyb_item{
				display: flex;
				padding-bottom: 23px;
				margin-top: 21px;
				border-bottom: 1px solid #E5E5E5;
				.desc_lyb_item_lef{
					width: 53px;
					height: 53px;
					margin-right: 23px;
					border-radius: 50%;
					.tx_icon{
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
				}
				.desc_lyb_item_rig{
					flex: 1;
					.desc_lyb_item_name{
						color: #333333;
						font-weight: bold;
						font-size: 12px;
						margin-bottom: 17px;
					}
					.desc_lyb_item_p{
						line-height: 2;
						font-size: 13px;
						color: #4A4A4A;
						margin-bottom: 30px;
					}
					.desc_lyb_item_time{
						font-size: 13px;
						color: #B8B8B8;
					}
				}
			}
		}
	}

	.desc_chart {
		.desc_chart_item {
			width: 600px;
			margin: 38px auto 0;
			box-sizing: border-box;

			.desc_chart_i {
				position: relative;

				.desc_chart_item_tit {
					height: 123px;
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					// background: rgba(0, 0, 0, .3);
					display: flex;
					align-items: center;
					padding-left: 38px;
					box-sizing: border-box;

					.icon {
						width: 103px;
						height: 22px;
					}
				}

				.desc_chart_item_bot {
					width: 100%;
					position: absolute;
					left: 0;
					bottom: 0;
					height: 53px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 0 36px;
					box-sizing: border-box;
					background-color: rgba(0, 0, 0, .3);

					.ew_img {
						width: 75px;
						height: 75px;
						background-color: red;
						transform: translateY(-40%);
					}

					span {
						color: #fff;
						font-size: 15px;
					}
				}

				.img {
					width: 100%;
					vertical-align: bottom;
					height: 100%;
				}
			}

			.desc_chart_p {
				padding-top: 23px;
				text-align: center;
				font-size: 15px;
				color: #333333;
			}
		}

	}

	.desc_box {
		position: relative;

		.desc_cont {
			min-height: 300px;
			padding: 0 23px;
			.desc_title {
				color: #000;
				font-size: 28px;
				font-weight: bold;
				margin-bottom: 37px;
			}

			.desc_p {
				font-size: 15px;
				color: #333333;
				margin-bottom: 30px;
				line-height: 2;
				display: flex;
				width: 72%;

				span {
					font-weight: bold;
				}
				.zhs{
					max-width: 500px;
					font-weight: normal;
					display: inline-block;
				}
				.des_c{
					flex: 1;
					font-weight: normal;
				}
			}

		}

		.desc_banner {
			position: absolute;
			right: 23px;
			top: 0;
			width: 300px;
			height: 225px;

			.bann_item {
				height: 225px;
				.img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
		}
	}

	.gall_box {
		//width: 870px;
		width: 1200px;
		margin: 0 auto;

		.gall_mbx {
			margin: 0 0 30px;
			padding: 37px 23px;

			span {
				font-size: 13px;
				cursor: pointer;
			}
		}

		.gall_slt {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			cursor: pointer;

			.icon {
				width: 20px;
				height: 20px;
				margin-right: 15px;
			}

			span {
				font-size: 15px;
				color: #22AB67;
			}
		}

		.gall_fy {
			margin: 30px 0 60px;

			.block {
				display: flex;
				justify-content: center;
			}
		}
	}
</style>
